export const REQUESTED_SAVE_RESCUE_DETAILS_RETRIEVE_RESULTS = "REQUESTED_SAVE_RESCUE_DETAILS_RETRIEVE_RESULTS";
export const REQUESTED_SAVE_RESCUE_DETAILS_RETRIEVE_RESULTS_SUCCESS = "REQUESTED_SAVE_RESCUE_DETAILS_RETRIEVE_RESULTS_SUCCESS";
export const REQUESTED_SAVE_RESCUE_DETAILS_RETRIEVE_RESULTS_FAILED = "REQUESTED_SAVE_RESCUE_DETAILS_RETRIEVE_RESULTS_FAILED";

export function saveRescueDetailsRetrieveResultsRequest(data) {
    return {
        type: REQUESTED_SAVE_RESCUE_DETAILS_RETRIEVE_RESULTS,
        payload: data
    };
}

export function saveRescueDetailsRetrieveResultsSuccess(data) {
    return {
        type: REQUESTED_SAVE_RESCUE_DETAILS_RETRIEVE_RESULTS_SUCCESS,
        payload: data
    };
}

export function saveRescueDetailsRetrieveResultsFailed(error) {
    return {
        type: REQUESTED_SAVE_RESCUE_DETAILS_RETRIEVE_RESULTS_FAILED,
        payload: error
    };
}
